import AccountSwitcherForm from './AccountSwitcherForm';

export type { AllLegacyAccountsQueryResult } from './graphql';
export { AllLegacyAccountsDocument } from './graphql';
export default AccountSwitcherForm;
